module.exports = __webpack_public_path__ + "images/fanatic-40070a01656ed09a14b322eec6aab3d0.png";